import { Link } from 'react-router-dom';

function serviceType(original) {
  return (
    <Link to={`/serviceadministratorservicetypes/edit/${original?.id}`}>
      {original?.serviceType || ''}
    </Link>
  );
}

function serviceTypeCode(original) {
  return original?.serviceTypeCode || '';
}

function status(original) {
  return original?.status ? 'Active' : 'In-Active';
}

export { serviceType, serviceTypeCode, status };
